import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'gbc-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    imports: [NgClass, NgStyle]
})
export class TileComponent {
  @Input()
  public flexy = false;

  @Input()
  public title: string;
  @Input()
  public contentHeight: string;

  constructor() {}
}
